/**
 * One canonical live price per screen.
 *
 * The instrument page had two. The header rendered `/api/quote/{ticker}`, cached
 * for 15 minutes; the analyst panel rendered — and computed "upside vs target"
 * from — the `current` that arrives with the analyst targets, cached for 6 hours.
 * The screen showed 57.85 at the top and worked the upside out against 59.67.
 *
 * These two functions exist so the rule is testable rather than a convention:
 * whenever a page has a live quote, that quote is the price every derived figure
 * on the page is computed from.
 */

/** The price a screen must use, given its header quote and whatever a secondary
 *  endpoint reported. The header quote wins whenever there is one. */
export function canonicalPrice(headerPrice, fallbackPrice = null) {
  return headerPrice != null ? headerPrice : fallbackPrice;
}

/** Percentage upside from `current` to the analyst mean `target`.
 *  Null unless both sides are real, non-zero numbers — a divide by a missing
 *  price is how a widget ends up claiming an infinite upside. */
export function upsidePct(target, current) {
  if (target == null || current == null) return null;
  if (!Number.isFinite(target) || !Number.isFinite(current) || current === 0) return null;
  return ((target - current) / current) * 100;
}
